// Accounting's things as RowList rows (BL-189 consolidation): what each row says, in words, with no
// drawing of its own. Close a month's Months.
import type { Row } from '../components/RowList/RowList.tsx';

export interface MonthRow {
  id: string;
  /** "October 2026". */
  month: string;
  closed: boolean;
  /** The day it was closed, in words ("Nov 3"). */
  closedOn?: string;
}

/**
 * The books' months, newest first: the month, Open or Closed a muted word, the day it was closed after it.
 * The month that may be reopened (the latest closed one) has Reopen at its end, for whoever may.
 */
export const monthRows = (
  rows: readonly MonthRow[],
  reopen?: { id: string; onPress: () => void } | null,
): Row[] =>
  rows.map((m) => ({
    id: m.id,
    name: m.month,
    word: { text: m.closed ? 'Closed' : 'Open', tone: 'muted' },
    ...(m.closedOn ? { after: { text: ` · closed ${m.closedOn}`, size: 'sm' as const } } : {}),
    ...(reopen?.id === m.id ? { end: { action: `Reopen ${m.month}`, onPress: reopen.onPress } } : {}),
  }));
